import { message } from 'antd';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '@/constants/messages';
import copy from 'copy-to-clipboard';
import {sendMessage, sendMessageErr} from "@/utils/slsClient";
import { supabaseAuthStore } from '@/utils/store/supabaseAuth';


// 统一的错误处理函数
export const handleError = (error: any, customMessage?: string, module?: string) => {
  const errCustomMsg = customMessage || ERROR_MESSAGES.COMMON_CREATION_FAILED;
  message.error(errCustomMsg);
  console.error(error);

  const errMsgFull = getErrJson(error);
  const moduleF = module || 'unset';
  
  // 直接从 supabaseAuthStore 中获取用户信息
  const uid = supabaseAuthStore.id || '';
  const userEmail = supabaseAuthStore.user?.email || '';

  sendMessageErr(uid, userEmail, module, moduleF, errMsgFull);
};

const getErrJson = (err: string) => {
  if (err) {
    return JSON.stringify(err, Object.getOwnPropertyNames(err), 2)
  } else {
    return "{\"message\": \"err is null\"}"
  }
};

// 统一的成功处理函数
export const handleSuccess = (successMessage: string) => {
  message.success(successMessage);
};

// 统一的警告处理函数
export const handleWarn = (successMessage: string) => {
  message.warning(successMessage);
};

// 统一的错误处理函数
export const handleWarnWithErr = (error: any, customMessage?: string) => {
  if(error){
    console.error(error)
  };

  const errorMessage = customMessage || ERROR_MESSAGES.COMMON_CREATION_FAILED;
      console.error(errorMessage)
};

// 复制到剪贴板的统一函数
export const copyToClipboard = (text: string, successMessage = '复制成功') => {
  const success = copy(text);
  if (success) {
    message.success(successMessage);
  } else {
    message.error('复制失败');
  }
  return success;
};